import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {CheckoutSteps, Host, Cart} from "../../../../common";

@Component({
  selector: 'checkout-header',
  standalone: false,
  template: `
    <div class="container checkout-header fixed-top">
      <div class="row h5 pt-2 pb-2 mb-0 align-items-center">
        <div class="col-auto pr-0">
          <button class="btn btn-outline-secondary" (click)="onBack()"><i class="far fa-arrow-alt-circle-left"></i></button>
        </div>
        <div class="col text-truncate"><a [routerLink]="['']">{{ host?.name }}</a></div>
        <div class="col-auto">
          <next-step-button [cart]="cart" [step]="step" [enabled]="canProceed" (next)="onNext()"></next-step-button>
          <!--
          <button class="btn btn-success" (click)="onNext()" [disabled]="!canProceed">
            <span i18n>Next</span>&nbsp;<i class="far fa-arrow-alt-circle-right"></i>
          </button>
          -->
        </div>
      </div>
    </div>
  `,
  styles: [`
    .row {
      flex-shrink: 0;
    }
  `]
})

export class CheckoutHeader implements OnInit, OnDestroy {
  @Input() host: Host;
  @Input() cart: Cart;
  @Input() step: CheckoutSteps;
  @Input() canProceed: boolean;
  @Output() back = new EventEmitter<undefined>();
  @Output() next = new EventEmitter<undefined>();

  ngOnInit() {
    document.querySelector('body').classList.add('has-fixed-top')
  }

  ngOnDestroy() {
    document.querySelector('body').classList.remove('has-fixed-top')
  }

  onBack() {
    this.back.emit();
  }

  onNext() {
    this.next.emit();
  }


}
